<div>
  @if (!editMode && label) {
    <span
      [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
      >
      {{label}}
    </span>
  }
  @if (!editMode) {
    <div class="selectPreviewData"
      (click)="editMode= !editMode"
      (keydown.space)="editMode= !editMode"
      (keydown.enter)="editMode= !editMode"
      aria-label='click to edit'
      >
      @if (data.length > 0) {
        <ul>
          @for (item of data; track $index) {
            <li>
              {{item}}
            </li>
          }
        </ul>
      }
      @if (data.length === 0) {
        <div>Click to add</div>
      }
    </div>
  }
  @if (editMode) {
    <div class="editMode">
      @if (items.length > 0) {
        <ul>
          @for (item of items; track $index; let i = $index) {
            <li>
              <div class="checkbox simpleCheckbox">
                <mat-checkbox
                  [ngModel]="item.isChecked"
                  (change)="onFocusOut(item)">
                  {{item.label}}
                </mat-checkbox>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
